module.exports = __webpack_public_path__ + "static/media/ff-home-null.1e783d38.svg";